import { useQuery } from '@tanstack/react-query';
import { changeHistoryViewerApi } from '../api/changeHistoryViewerApi';

/**
 * GET /change-history-viewer/revisions/{rev}?entityId=...
 * queryKey: ['change-history-viewer', 'snapshot', entityId, rev]
 *
 * entityId 또는 rev 가 undefined 이면 쿼리 비활성화
 */
export function useRevisionSnapshot(entityId: number | undefined, rev: number | undefined) {
  return useQuery({
    queryKey: ['change-history-viewer', 'snapshot', entityId, rev] as const,
    queryFn: () =>
      changeHistoryViewerApi.getRevisionSnapshot({
        rev: rev!,
        entityId: entityId!,
      }),
    enabled: entityId !== undefined && rev !== undefined,
    staleTime: 60_000,
  });
}
